import { ERROR_CODES } from "./inputValidators"

const getLoginErrorMsg = errorCode => {
  if (!errorCode) {
    return ""
  }

  switch (errorCode) {
    case ERROR_CODES.EMPTY_EMAIL:
      return "Please enter your email address"
    case ERROR_CODES.INVALID_EMAIL_FORMAT:
    case ERROR_CODES.SPAM_EMAIL:
      return "Please enter a valid email address"
    case ERROR_CODES.EMPTY_PASSWORD:
      return "Please enter your password"
    default:
      return ""
  }
}

const getSignUpErrorMsg = errorCode => {
  if (!errorCode) {
    return ""
  }

  switch (errorCode) {
    case ERROR_CODES.EMPTY_EMAIL:
      return "Please enter your email address"
    case ERROR_CODES.INVALID_EMAIL_FORMAT:
    case ERROR_CODES.SPAM_EMAIL:
      return "Please enter a valid email address"
    case ERROR_CODES.PASSWORD_NOT_ALPHANUMERIC:
      return "Password must be alphanumeric"
    case ERROR_CODES.PASSWORD_LENGTH_LESS_THAN_8:
      return "Password must have at least 8 characters"
    case ERROR_CODES.EMPTY_PASSWORD:
      return "Please enter your desired password"
    case ERROR_CODES.EMPTY_FIRST_NAME:
      return "Please enter your first name"
    case ERROR_CODES.EMPTY_LAST_NAME:
      return "Please enter your last name"
    case ERROR_CODES.VERIFY_PASSWORD_DO_NOT_MATCH:
      return "Must match with password"
    default:
      return ""
  }
}

const getForgotPasswordErrorMsg = errorCode => {
  if (!errorCode) {
    return ""
  }

  switch (errorCode) {
    case ERROR_CODES.EMPTY_EMAIL:
      return "Please enter your email address"
    case ERROR_CODES.INVALID_EMAIL_FORMAT:
    case ERROR_CODES.SPAM_EMAIL:
      return "Please enter a valid email address"
    default:
      return ""
  }
}

const getResetPasswordErrorMsg = errorCode => {
  if (!errorCode) {
    return ""
  }

  switch (errorCode) {
    case ERROR_CODES.EMPTY_PASSWORD:
      return "Please enter your desired password"
    case ERROR_CODES.VERIFY_PASSWORD_DO_NOT_MATCH:
      return "Must match with password"
    case ERROR_CODES.PASSWORD_LENGTH_LESS_THAN_8:
      return "Password must have at least 8 characters"
    default:
      return ""
  }
}

const getRegisterEmailErrorMsg = errorCode => {
  if (!errorCode) {
    return ""
  }

  switch (errorCode) {
    case ERROR_CODES.EMPTY_EMAIL:
      return "Please enter your email address"
    case ERROR_CODES.INVALID_EMAIL_FORMAT:
    case ERROR_CODES.SPAM_EMAIL:
      return "Please enter a valid email address"
    default:
      return ""
  }
}

export {
  getLoginErrorMsg,
  getSignUpErrorMsg,
  getForgotPasswordErrorMsg,
  getResetPasswordErrorMsg,
  getRegisterEmailErrorMsg,
}
